{
  "account": {"open": "Kontomenü von {{name}}"},
  "back": "Zurück",
  "backKey": "Zurück (Esc)",
  "closeSidebar": "Seitenleiste schließen",
  "column": {"hide": "{{column}} ausblenden", "show": "{{column}} einblenden"},
  "openSidebar": "Seitenleiste öffnen",
  "resizeSidebar": "Breite der Seitenleiste ändern",
  "sectionsNavigation": "Bereiche",
  "sidebar": "Seitenleiste",
  "tabs": {
    "activeGroup": "Die Gruppe, in der Sie arbeiten",
    "choose": "Tab auswählen",
    "close": "Schließen",
    "closeNamed": "{{name}} schließen",
    "closeOthers": "Andere schließen",
    "count_one": "{{count}} Tab",
    "count_other": "{{count}} Tabs",
    "failed": "Diese Seite ließ sich nicht anzeigen.",
    "more": "Weitere Tabs",
    "moveBeside": "Zur Seite verschieben",
    "moveGroup": "Diese Gruppe verschieben",
    "newTab": "Neuer Tab",
    "openBeside": "Daneben öffnen",
    "openNewTab": "In neuem Tab öffnen",
    "page": {
      "batch": "Stapelverarbeitung",
      "importProposal": "Importvorschlag",
      "item": "Element",
      "problemReport": "Problem melden",
      "review": "Review"
    },
    "preparationTitle": "{{heading}}: {{name}}",
    "recentlyClosed": "Kürzlich geschlossen",
    "resize": "Größe der Gruppen ändern",
    "retry": "Erneut versuchen",
    "workflowTitle": "Prozessschema: {{name}}"
  }
}
